WiseMetering.Views.Ui.Widget.Co2Displayer = WiseMetering.Views.Ui.Widget.Base.extend({
    templateID: 'templates/ui/widgets/co2_displayer',
    chartDisplayer: false,

    initialize: function(params) {
        WiseMetering.Views.Ui.Widget.Base.prototype.initialize.call(this, params);
    }
});
